// Add-to-calendar helpers. Times are UTC: 18:00 CEST = 16:00 UTC.
// End time at 00:00 UTC the next day per the brief's reference template.

export const GOOGLE_CALENDAR_URL =
  "https://calendar.google.com/calendar/event?action=TEMPLATE&text=Hans%27s+50th+Birthday&dates=20260613T160000Z/20260614T000000Z&location=Stork+Club+House+of+Rye%2C+Am+Flutgraben+2%2C+12435+Berlin&details=Drinks%2C+food%2C+and+good+company.+Details%3A+50.hansluther.com";

const ICS_UID = "hans-50-2026-06-13@50.hansluther.com";

function nowDtstamp(): string {
  return new Date()
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}/, "");
}

function buildIcs(): string {
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Hans 50//EN",
    "BEGIN:VEVENT",
    `UID:${ICS_UID}`,
    `DTSTAMP:${nowDtstamp()}`,
    "DTSTART:20260613T160000Z",
    "DTEND:20260614T000000Z",
    "SUMMARY:Hans's 50th Birthday",
    "LOCATION:Stork Club House of Rye, Am Flutgraben 2, 12435 Berlin",
    "DESCRIPTION:Drinks, food, and good company. Details: 50.hansluther.com",
    "URL:https://50.hansluther.com",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
}

export function downloadIcs(): void {
  const blob = new Blob([buildIcs()], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "hans-50.ics";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(url);
    a.remove();
  }, 500);
}

// 2026-06-13 18:00 Europe/Berlin = 2026-06-13 16:00 UTC
export const EVENT_UTC_MS = Date.UTC(2026, 5, 13, 16, 0, 0);
